"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingType = void 0;
var BuildingType;
(function (BuildingType) {
    BuildingType["Household"] = "Household";
    BuildingType["HealthCenter"] = "HealthCenter";
    BuildingType["Dispensary"] = "Dispensary";
    BuildingType["School"] = "School";
    BuildingType["PrimarySchool"] = "PrimarySchool";
    BuildingType["SecondarySchool"] = "SecondarySchool";
    BuildingType["PublicAdministration"] = "PublicAdministration";
    BuildingType["TradingPlace"] = "TradingPlace";
    BuildingType["BusStop"] = "BusStop";
})(BuildingType || (exports.BuildingType = BuildingType = {}));
